import ModelCardSkeleton from './ModelCardSkeleton.tsx'

type ModelCardSkeletonVariant = 'bots' | 'selector'

interface Props {
	count?: number
	variant?: ModelCardSkeletonVariant
	showRadio?: boolean
	grouped?: boolean
}

export default function ModelCardsGridSkeleton({
	count = 6,
	variant = 'bots',
	showRadio = false,
	grouped = false,
}: Props) {
	if (grouped) {
		return (
			<div className="model-list" aria-hidden="true">
				<div className="model-group">
					<div className="model-group-title">Загрузка...</div>
					{Array.from({ length: count }).map((_, index) => (
						<ModelCardSkeleton key={index} variant={variant} showRadio={showRadio} />
					))}
				</div>
			</div>
		)
	}

	return (
		<div className="models-grid" aria-hidden="true">
			{Array.from({ length: count }).map((_, index) => (
				<ModelCardSkeleton key={index} variant={variant} showRadio={showRadio} />
			))}
		</div>
	)
}
